import "./ContactUs.css";
import emailjs from "@emailjs/browser";
import { useRef, useState, useEffect } from "react";
import Navbar from "../MainComponents/Navbar";
import { IoBalloon } from "react-icons/io5";
import { IoIosMail } from "react-icons/io";
import { FaPhoneAlt } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa";
import Footer from "../MainComponents/Footer";
import { useTranslation } from "react-i18next";

function ContactUs() {
  const { t } = useTranslation();
  const form = useRef();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => { setIsLoaded(true); }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            obs.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    const els = document.querySelectorAll(
      '.reveal, .reveal-left, .reveal-right, .reveal-scale, .reveal-stagger'
    );
    els.forEach((el) => observer.observe(el));
    return () => els.forEach((el) => observer.unobserve(el));
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_8zshh7d",
        "template_b04fl1h",
        form.current,
        "Czr-9Pq_QP6oyvPNK"
      )
      .then(
        () => {
          alert(t('contact.messageSent'));
        },
        (error) => {
          alert(t('contact.failed'));
        }
      );
  };

  return (
    <div className="contact-page">

      <Navbar />

      {/* HERO SECTION */}

      <div className={`contact-hero ${isLoaded ? 'animate-in' : ''}`}>

        <h1>
          {t('contact.heroTitle')}
        </h1>

        <p>
          {t('contact.heroDesc')}
        </p>

      </div>

      {/* CONTACT SECTION */}

      <div className="contact-box-section">

        {/* LEFT */}

        <div className="contact-left-box reveal-left">

          <h2>{t('contact.getInTouch')}</h2>

          <p className="left-description">
            {t('contact.leftDescription')}
          </p>

          <div className="contact-item">

            <div className="contact-icon">
              <IoBalloon />
            </div>

            <div>

              <h3>{t('contact.headOffice')}</h3>

              <p>Jalan Cempaka Wangi No 22</p>

              <p>Jakarta - Indonesia</p>

            </div>

          </div>

          <div className="contact-item">

            <div className="contact-icon">
              <IoIosMail />
            </div>

            <div>

              <h3>{t('contact.emailUs')}</h3>

              <p>support@cravedash.com</p>

              <p>hello@cravedash.com</p>

            </div>

          </div>

          <div className="contact-item">

            <div className="contact-icon">
              <FaPhoneAlt />
            </div>

            <div>

              <h3>{t('contact.callUs')}</h3>

              <p>Phone : +6221.2002.2012</p>

              <p>Fax : +6221.2002.2013</p>

            </div>

          </div>

          <div className="social-section">

            <p>{t('contact.followSocial')}</p>

            <div className="social-icons">

              <div className="social-icon">
                <FaInstagram />
              </div>

              <div className="social-icon">
                <FaFacebook />
              </div>

              <div className="social-icon">
                <FaSquareXTwitter />
              </div>

              <div className="social-icon">
                <FaYoutube />
              </div>

            </div>

          </div>

        </div>

        {/* RIGHT */}

        <div className="contact-right-box reveal-right">

          <h2>{t('contact.sendMessage')}</h2>

          <form
            ref={form}
            onSubmit={sendEmail}
            className="contact-form"
          >

            <div className="input-row">

              <input type="text" name="name" placeholder={t('contact.yourName')} aria-label={t('contact.yourName')} />

              <input type="text" name="company" placeholder={t('contact.companyName')} aria-label={t('contact.companyName')} />

            </div>

            <div className="input-row">

              <input type="text" name="phone" placeholder={t('contact.phone')} aria-label="Phone number" />

              <input type="email" name="email" placeholder={t('contact.emailPlaceholder')} aria-label="Email address" />

            </div>

            <input type="text" name="subject" placeholder={t('contact.subjectPlaceholder')} aria-label="Subject" />

            <textarea name="message" placeholder={t('contact.messagePlaceholder')} aria-label="Message"></textarea>

            <button type="submit">
              {t('contact.send')}
            </button>

          </form>

        </div>

      </div>

      {/* MAP SECTION */}

      <div className="map-section">

        <img
          src="https://images.unsplash.com/photo-1524661135-423995f22d0b?q=80&w=2070&auto=format&fit=crop"
          alt="map"
          className="map-image"
        />

        <div className="map-card reveal-left">

          <h2>{t('contact.hqTitle')}</h2>

          <p className="map-location">
            {t('contact.district')}
          </p>

          <p className="map-time">
            {t('contact.openHours')}
          </p>

          <button type="button">
            {t('contact.getDirections')}
          </button>

        </div>

      </div>

      {/* FOOTER */}

      <Footer />

    </div>
  );
}

export default ContactUs;